<template>
    <BaseModal
        class="cart-discount-list-modal"
        :closable="true"
        :hasHeader="false"
        :hasFooter="false"
        ref="baseModalComponent"
    >
        <template v-slot:body>
            <div class="cart-discount-list-form form-group row">
                <CartDiscountsList
                    v-if="isVisible"
                    class="col-md"
                    @allDiscountsRemoved="close"
                    @discountRemoved="onDiscountRemoved"
                />
            </div>
        </template>
    </BaseModal>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    import CartDiscountsList from "@/components/cart/CartDiscountsList.vue";
    import BaseModal from "@/components/dialog/BaseModal.vue";

    const emit = defineEmits(["discountRemoved"]);

    // define html refs
    const baseModalComponent = ref<InstanceType<typeof BaseModal> | null>(null);

    function onDiscountRemoved() {
        emit("discountRemoved");
    }

    // define exposed
    const isVisible = ref(false);
    function show() {
        isVisible.value = true;
        baseModalComponent.value?.show();
    }

    function close() {
        isVisible.value = false;
        baseModalComponent.value?.close();
    }

    defineExpose({
        show,
        close,
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    .modal.cart-discount-list-modal {
        .modal-body {
            padding: 1.5em 2em;
        }

        .cart-discount-list-form {
            margin-bottom: 1em;
        }
    }
</style>
